import { getPageType } from '~/events/utils/pageType'
import productTransformer from '../dataLayerBasic/transformers/product.transformer'

export default ({ eventBus, eventDefinitions }) => {
  eventBus.$on(eventDefinitions.CATALOG.PAGE_VIEW, ({ categoryStore, items, shouldTrack }) => {
    if (!shouldTrack) return

    const itemListId = categoryStore?.code || null
    const itemListName = categoryStore?.fullname || null
    const currency = 'CZK'

    dataLayer.push({ ecommerce: null })

    if (!items || items.length === 0) {
      return pushItemListEvent({
        item_list_id: itemListId,
        item_list_name: itemListName,
        currency,
        items: [],
        mkt_val_all: 0,
        total_value: 0,
        prod_ids: [],
        total_value_all: [],
      })
    }

    const transformedItems = items.map((item, i) => productTransformer(item.product, 1, 0, 0, i))
    const prod_ids = transformedItems.map(item => String(item.item_id))
    const total_value_all = transformedItems.map(item => item.price * item.quantity)
    const mkt_val_all = total_value_all.reduce((sum, val) => sum + val, 0)

    pushItemListEvent({
      item_list_id: itemListId,
      item_list_name: itemListName,
      currency,
      items: transformedItems,
      mkt_val_all,
      total_value: mkt_val_all,
      prod_ids,
      total_value_all,
    })
  })
}

function pushItemListEvent({
  item_list_id,
  item_list_name,
  currency,
  items,
  mkt_val_all,
  total_value,
  prod_ids,
  total_value_all,
}) {
  dataLayer.push({
    event: 'view_item_list',
    ecommerce: {
      item_list_id,
      item_list_name,
      currency,
      mkt_val_all,
      items,
      google_tag_params: {
        ecomm_pagetype: getPageType(),
        ecomm_prodid: prod_ids,
        ecomm_totalvalue: total_value,
        ecomm_totalvalue_all: total_value_all,
      },
    },
  })
}
